/** Exact canonical spelling only: no edit distance, token removal or postal-prefix inference. */
export function normalizeFrenchCity(value) {
    return value
        .normalize('NFKD')
        .replace(/\p{M}/gu, '')
        .toLowerCase()
        .replace(/œ/gu, 'oe')
        .replace(/æ/gu, 'ae')
        .replace(/\bste\b/gu, 'sainte')
        .replace(/\bst\b/gu, 'saint')
        .replace(/[\s\p{Pd}'’.,]+/gu, ' ')
        .trim();
}
export function regionAddressKey(address) {
    return JSON.stringify([
        address.countryCode?.trim().toUpperCase() ?? '',
        address.postalCode?.trim() ?? '',
        normalizeFrenchCity(address.city ?? ''),
    ]);
}
export function decideFrenchRegion(address, suggestions) {
    const empty = { region: null, regionCode: null, city: null };
    if (address.countryCode?.trim().toUpperCase() !== 'FR')
        return { status: 'UNSUPPORTED', ...empty };
    const postalCode = address.postalCode?.trim() ?? '';
    if (!/^\d{5}$/u.test(postalCode))
        return { status: 'INCOMPLETE', ...empty };
    const rows = suggestions.filter((row) => row.countryCode === 'FR' && row.postalCode === postalCode);
    if (rows.length === 0)
        return { status: 'NO_MATCH', ...empty };
    const city = normalizeFrenchCity(address.city ?? '');
    const candidates = city === '' ? rows : rows.filter((row) => normalizeFrenchCity(row.city) === city);
    if (candidates.length === 0)
        return { status: 'CONFLICT', ...empty };
    if (candidates.some((row) => !row.region?.trim() || !row.regionCode?.trim()))
        return { status: 'MISSING_REGION', ...empty };
    const first = candidates[0];
    if (first === undefined)
        return { status: 'NO_MATCH', ...empty };
    if (candidates.some((row) => row.regionCode !== first.regionCode || row.region !== first.region))
        return { status: 'AMBIGUOUS', ...empty };
    return {
        status: 'RESOLVED',
        region: first.region,
        regionCode: first.regionCode,
        city: candidates.length === 1 ? first.city : null,
    };
}
//# sourceMappingURL=address-region.js.map